import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import styles from './index.module.scss';
import _ from 'lodash';

const SEOFields = props => {
  const [editFields, setEditFields] = useState<boolean>(false);
  const {
    updatedSupplier,
    supplier,
    handleEditCancel,
    loading,
    setUpdatedSupplier,
    updateSupplierFn,
  } = props;

  const handleEdit = (key: string, value: string) => {
    setUpdatedSupplier({
      ...updatedSupplier,
      [key]: value,
    });
  };
  
  const handleEditCancelFn = () => {
    handleEditCancel({
      title: supplier.title || '',
      description: supplier.description || '',
      enTitle: supplier.enTitle || '',
      enDescription: supplier.enDescription || '',
    });
    setEditFields(false);
  };

  const handlePrimaryAction = async () => {
    if (editFields) {
      await updateSupplierFn();
    }
    setEditFields(!editFields);
  };

  const SEOGroup = (
    { label, detail = '', isTextArea = false, propertyKey }:
      { label: string; detail: string; isTextArea?: boolean; propertyKey: string },
  ) => (
    <div className={styles['seo-group']}>
      <div className={styles['label']}>{label}</div>
      {editFields ? (
        isTextArea ? (
          <textarea
            key={propertyKey}
            disabled={loading}
            className={'form-control'}
            value={detail}
            onChange={e => handleEdit(propertyKey, e.target.value)}
          />
        ) : (
          <input
            key={propertyKey}
            disabled={loading}
            className={'form-control'}
            value={detail}
            onChange={e => handleEdit(propertyKey, e.target.value)}
          />
        )
      ) : (
        <div className={styles['info']}>{detail || '-'}</div>
      )}
    </div>
  );

  return (
    <div className={styles['seo-section-container']}>
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>SEO Fields</div>
        <div className={'d-flex'}>
          <ActionButton
            text={editFields ? 'Save' : 'Edit'}
            active={true}
            isLoading={false}
            onClick={handlePrimaryAction}
          />
          {editFields && (
            <ActionButton
              text={'Cancel'}
              active={true}
              isLoading={false}
              onClick={handleEditCancelFn}
              customClass={styles['cancel-button']}
            />
          )}
        </div>
      </div>
      <div className={styles['seo-fields-section']}>
        {SEOGroup({
          detail: updatedSupplier.title,
          label: 'Spanish Title',
          propertyKey: 'title',
        })}
        {SEOGroup({
          detail: updatedSupplier.enTitle,
          label: 'English Title',
          propertyKey: 'enTitle',
        })}
        {SEOGroup({
          detail: updatedSupplier.description,
          label: 'Spanish Description',
          propertyKey: 'description',
          isTextArea: true,
        })}
        {SEOGroup({
          detail: updatedSupplier.enDescription,
          label: 'English Description',
          propertyKey: 'enDescription',
          isTextArea: true,
        })}
      </div>
    </div>
  );
};

export default SEOFields;